<template>
  <BaseSelect v-bind="$attrs"
              :value="!isValueNumber ? value : null"
              :options="items"
              textKey="title"
              :cancelable="cancelable"
              :loading="pending"
              :getOptionText="getOptionText"
              :filterable="!!directionId || filterable"
              @search="onSearch"
              @focus="onSelectFocus"
              @input="onInput">
  </BaseSelect>
</template>

<script>
  import {CancelToken} from 'axios'
  import {http} from '@/axios'

  export default {
    props: {
      directionId: {
        type: Number
      },
      value: {
        type: [Object, Number]
      },
      preload: {
        type: Boolean,
        default: false
      },
      selectAfterLoad: {
        type: Boolean,
        default: false
      },
      cancelable: {
        type: Boolean,
        default: true
      },
      url: {
        type: String,
        default: `api/vacancies/categories-list-all`
      },
      params: {
        type: Object,
      },
      filterable: Boolean
    },
    data() {
      return {
        timer: null,
        pending: false,
        loaded: false,
        items: []
      }
    },
    computed: {
      isValueNumber() {
        return !!(this.value && !isNaN(this.value))
      }
    },
    methods: {
      load(search) {
        if (this.cancel) this.cancel()

        setTimeout(() => {
          this.pending = true

          http.get(this.url, {
            params: {
              ...this.params,
              direction_id: this.directionId,
              search_query: search
            },
            cancelToken: new CancelToken((c) => this.cancel = c)
          }).then(({data}) => {
            this.items = data.data
            this.checkIsValueNumber()
            if (this.selectAfterLoad && !this.value) {
              this.onInput(this.items[0])
            }

            this.loaded = !search;

          }).finally(() => {
            this.pending = false
          })
        })
      },
      onSearch(search, toggleLoading) {
        if (this.directionId) return
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.load(search, toggleLoading)
        }, 300)
      },
      onSelectFocus() {
        this.load()
      },
      onInput(value) {
        this.$emit('input', value)
      },
      getOptionText(option) {
        return option && (option.category && option.category.title || option.title)
      },
      checkIsValueNumber() {
        if (this.isValueNumber) {
          let value = this.items.find(item => item.id === +this.value)
          if (value) {
            this.$emit('setValue', value)
          }
        }
      },
      checkIsSameDirection(directionId) {
        if (this.isValueNumber) return false
        if (!this.value) return false
        return parseFloat(this.value.category.direction_id) === parseFloat(directionId)
      }
    },
    watch: {
      value() {
        this.checkIsValueNumber()
      },
      directionId() {
        this.loaded = false

        if (this.directionId) {
          if (!this.checkIsSameDirection(this.directionId)) {
            this.load()
          }
        } else {
          this.items = null
          this.$emit('input', null)
        }
      }
    },
    created() {
      if (this.directionId) {
        this.load()
      } else if (this.preload) {
        this.load()
      }
    }
  }
</script>

<style lang="less">

</style>
